<template>
    <div class="pagination" v-if="count != 0">
        <div class="arrowBtn" @click="prevBtn"><img src="../images/home/arrow_left.png" alt=""></div>
        <div class="pageTab" v-for="(item,index) in Math.ceil(count/pageSize)" :key="index" :class="(index+1) == pageIdx?'active':''" @click="pageBtn(index+1)">{{item}}</div>
        <div class="arrowBtn" @click="nextBtn"><img src="../images/home/arrow_right.png" alt=""></div>
    </div>
</template>

<script>
    export default {
        naem:'pagination',
        data() {
            return {
                pageIdx: 1,
                minPage: 0,
                maxPage: 10,
            }
        },
        props:{
            count:{
                type: Number,
                default: 0,
            },
            pageSize:{
                type: Number,
                default: 10,
            },
        },
        mounted(){},
        methods:{
            // 当前页
            pageBtn(idx){
                if(this.pageIdx != idx){
                    this.pageIdx = idx;
                    if(idx == 1){
                        this.maxPage = this.pageSize;
                        this.minPage = 0;
                    }else{
                        this.minPage = (idx*this.pageSize)-this.pageSize;
                        this.maxPage = idx*this.pageSize;
                    }
                    this.$emit('pageNumber',this.minPage,this.maxPage);
                }
            },
            // 上一页
            prevBtn(){
                if(this.pageIdx > 1){
                    this.pageIdx--;
                    if(this.pageIdx == 1){
                        this.maxPage = this.pageSize;
                        this.minPage = 0;
                    }else{
                        this.minPage = (this.pageIdx*this.pageSize)-this.pageSize;
                        this.maxPage = this.pageIdx*this.pageSize;
                    }
                    this.$emit('pageNumber',this.minPage,this.maxPage);
                }
            },
            // 下一页
            nextBtn(){
                if(this.pageIdx < Math.ceil(this.count/this.pageSize)){
                    this.pageIdx++;
                    this.minPage = (this.pageIdx*this.pageSize)-this.pageSize;
                    this.maxPage = this.pageIdx*this.pageSize;
                    this.$emit('pageNumber',this.minPage,this.maxPage);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .pagination{
        margin:20px auto;
        display: flex;
        justify-content: center;
        .arrowBtn{
            margin:0 8px;
            width:24px;
            height:24px;
            padding:6px;
            cursor: pointer;
            @include h-radius(2px);
            transition: background 0.3s;
            img{
                margin:0 auto;
            }
            &:hover{
                @include h-bgColor(var(--colorF3));
            }
        }
        .pageTab{
            cursor: pointer;
            width:24px;
            text-align: center;
            font-weight: 500;
            margin:0 5px;
            transition: background 0.3s;
            @include h-radius(2px);
            @include h-fontSize(var(--color33),14px,24px);
            &:hover{
                @include h-bgColor(var(--colorF3));
                @include h-fontSize(var(--color33),14px,24px);
            }
        }
        .active{
            @include h-bgColor($colorE7);
            @include h-fontSize($colorFF,14px,24px);
            &:hover{
                @include h-bgColor($colorE7);
                @include h-fontSize($colorFF,14px,24px);
            }
        }
    }

    :root[theme="dark"]{
        .pagination{
            .arrowBtn{
                background:var(--color1C);
                &:hover{
                    @include h-bgColor(var(--color66));
                }
            }
            .pageTab{
                @include h-bgColor(var(--color1C));
                &:hover{
                    @include h-bgColor(var(--color66));
                    @include h-fontSize($colorFF,14px,24px);
                }
            }
            .active{
                @include h-bgColor($colorE7);
                @include h-fontSize($colorFF,14px,24px);
                &:hover{
                    @include h-bgColor($colorE7);
                    @include h-fontSize($colorFF,14px,24px);
                }
            }
        }
    }
</style>